import dynamic from 'next/dynamic';

// The editor carries TipTap, its extensions and the toolbar, the largest
// piece of JavaScript in the app, and it only exists while a doc is open.
// Everyone imports it from here, so everyone gets it as a separate chunk
// that loads when it is first rendered.
export const DocEditor = dynamic(
  () => import('./DocEditor').then((module) => module.DocEditor),
  { ssr: false },
);

// Start loading the editor chunk ahead of time, e.g. when the user hovers
// the compose card, so opening it feels instant.
export const preloadDocEditor = (): void => {
  void import('./DocEditor');
};
